import { UseSuspenseQueryOptions, useMutation, useQueryClient } from '@tanstack/react-query';

import { Id } from '@feature/utils';
import { Validation } from '@feature/validation';
import { generateValidationApi, generateValidationOptions } from '@feature/validation/validationGenerator';

const validationApi = generateValidationApi('/validation/abstract');

const { getHistoryOptions, validateOptions, getCurrentOptions } = generateValidationOptions('abstract', validationApi);

export function getAbstractValidationHistoryOptions(abstractId: Id): UseSuspenseQueryOptions<Validation[]> {
  return getHistoryOptions(abstractId);
}

export function getAbstractValidationOptions(abstractId: Id): UseSuspenseQueryOptions<Validation | null> {
  return getCurrentOptions(abstractId);
}

export function useValidateAbstract(abstractId: Id) {
  const queryClient = useQueryClient();
  return useMutation(validateOptions(abstractId, queryClient));
}
